import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { INFRASTRUCTURE_MF_NAME } from 'shared/constants/microfrontends';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { pageDataSelector } from 'shared/selectors/pageData/root/pageDataSelector';
import { getInfrastructureMicrofrontendManifest } from 'shared/services/getInfrastructureMicrofrontendManifest/getInfrastructureMicrofrontendManifest';

export function useInfrastructureMicrofrontend() {
  const pageData = useSelector(pageDataSelector);
  const ctx = useApplicationContext();
  const [manifest, setManifest] = useState<IMicrofrontendManifest | null>(null);
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>('loading');

  const fetchManifest = useCallback(async () => {
    setStatus('loading');
    const mfManifest = await getInfrastructureMicrofrontendManifest(ctx, pageData);
    if (mfManifest !== null) {
      ctx.microfrontendsRegistry.register(mfManifest);
      setStatus('success');
    }
    setStatus('error');
  }, [ctx, pageData]);

  useEffect(() => {
    const mf = ctx.config.get<IMicrofrontendManifest>(`microfrontendManifests.${INFRASTRUCTURE_MF_NAME}`);

    if (!mf) {
      fetchManifest();
    } else {
      setManifest(mf);
      setStatus('success');
    }
  }, [ctx.config, fetchManifest]);

  return { manifest, fetchManifest, status };
}
